/**
 * @description Formulário para adicionar dado balístico
 * @author Diego Sabino Amorim de Araújo
 * @file ModalItemBalistico.js
 *
 * @license Copyright (c) 2021 SIGEP DIGETI ITEP/RN
 */

import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/styles'
import { TextField, Grid, CardContent, FormControl, Button, CardHeader } from '@material-ui/core'
import validate from 'validate.js'
import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
  root: {},
  fieldGroup: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
  },
  flexGrow: {
    flexGrow: 1,
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  carregando: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 20,
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}))

export const ModalItemBalistico = (props) => {
  const { className, handleAdicionarItemBalistico, ...rest } = props
  const classes = useStyles()

  const [formState, setFormState] = useState({
    isValid: false,
    values: {},
    touched: {},
    errors: {},
  })

  const schema = {
    nome: {
      presence: { allowEmpty: false, message: 'é obrigatório' },
    },
  }

  useEffect(() => {
    const errors = validate(formState.values, schema)
    setFormState((formState) => ({
      ...formState,
      isValid: !errors,
      errors: errors || {},
    }))
    
  }, [formState.values])

  const hasError = (field) => !!(formState.touched[field] && formState.errors[field])

  const handleSubmit = async (event) => {
    event.preventDefault()
    handleAdicionarItemBalistico(formState.values.nome)
  }

  const handleChange = (event) => {
    event.persist()
    setFormState((formState) => ({
      ...formState,
      values: {
        ...formState.values,
        [event.target.name]:
          event.target.type === 'checkbox' ? event.target.value : event.target.value,
      },
      touched: {
        ...formState.touched,
        [event.target.name]: true,
      },
    }))
  }

  return (
    <CardContent>
      <form
        id="form-gerenciamento-balistico"
        onSubmit={handleSubmit}
        {...rest}
        className={clsx(classes.root, className)}
      >
        <CardHeader title="PREENCHA O FORMULÁRIO" />
        <Grid className={classes.fieldGroup} alignItems="center" container justify="space-between">
          <Grid className={classes.item} item md={12} sm={12} xs={12}>
            <FormControl
              style={{
                minWidth: '100%',
                maxWidth: '100%',
              }}
            >
              <TextField
                error={hasError('nome')}
                fullWidth
                helperText={hasError('nome') ? formState.errors.nome[0] : null}
                label="Nome do item"
                rows={2}
                name="nome"
                onChange={handleChange}
                value={formState.values.nome || ''}
              />
            </FormControl>
          </Grid>
        </Grid>

        <Grid>
          <div className={classes.buttons}>
            <Button
              form="form-gerenciamento-balistico"
              type="submit"
              color="secondary"
              variant="contained"
              className={classes.button}
            >
              Adicionar item
            </Button>
          </div>
        </Grid>
      </form>
    </CardContent>
  )
}
